<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="structure"> </p>
<p class="Epi"><span class="CharOverride-16"> </span></p>
<p class="Epi"><span class="CharOverride-16"> </span></p>
<p class="Epi"><span class="CharOverride-16"> </span></p>
<p class="Epi"><span class="CharOverride-16"> </span></p>
<p class="Epi"><span class="CharOverride-16">The key to everything is patience.</span></p>
<p class="Epi"><span class="CharOverride-16">You get the chicken by hatching</span></p>
<p class="Epi"><span class="CharOverride-16">the egg, not by smashing it.</span></p>
<p class="Attribut">Arnold H. Glasgow</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ThePowerOfPatience-3.vue?4af93aa5